import { Component, Input } from "@angular/core";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";

@Component({
  selector: "gh-test-modal-component",
  templateUrl: "./test-modal.component.html",
})
export class TestModalComponent {
  @Input() title?: string;
  @Input() subtitle?: string;

  constructor(private modalRef: UiModalRef) {}

  destroyModal(): void {
    this.modalRef.destroy({ data: "this the result data" });
  }
}
